import { FuturesMarketAsset } from '../types';
export const PERENNIAL_EXCLUDED_MARKETS = [FuturesMarketAsset.RLB, FuturesMarketAsset.MEEM];
